import { render } from "./FAQAccordionBlock.vue?vue&type=template&id=5fcecf26"
import script from "./FAQAccordionBlock.vue?vue&type=script&lang=js"
export * from "./FAQAccordionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__